import type Message from "@travily/types/models/MessagesMessage";
import { Image } from "@ui/components/Image";

interface MessageAttachmentsProps {
  attachments: Message["attachments"];
}

/**
 * Images sent with a message, above its words — the same utterance, so they share the bubble's
 * width and corner. One image fills that width; several tile two-up, which is as far as a bubble
 * can subdivide before a thumbnail stops being worth tapping.
 */
export function MessageAttachments({ attachments }: MessageAttachmentsProps) {
  if (attachments.length === 0) return null;

  return (
    <div className={`grid gap-1 ${attachments.length > 1 ? "grid-cols-2" : "grid-cols-1"}`}>
      {attachments.map((attachment) => (
        <Image
          key={attachment.src}
          className="w-full rounded-2xl object-cover"
          image={attachment}
          sizes="(min-width: 768px) 32rem, 78vw"
        />
      ))}
    </div>
  );
}
